import { initAnalytics } from '../../utils/analytics';

export default {
  data() {
    return {
      defaultAnalyticsViewData: {
        siteId: 'rei', // optional override in the component with the analyticsViewData() computed value
      },
    };
  },
  computed: {
    analyticsMap() {
      if (!this.renderingMap) return {};
      let count = 1;
      return Object.keys(this.renderingMap).reduce((acc, section) => {
        if (this.renderingMap[section]) {
          acc[section] = `ct_${count}_${section}`;
          count += 1;
        }

        return acc;
      }, {});
    },
  },
  mounted() {
    if (window && window.metrics) {
      window.metrics.view(
        {
          ...this.defaultAnalyticsViewData,
          ...this.analyticsViewData,
        },
        initAnalytics({
          metrics: window.metrics,
          wrapSelector: '#app',
        }),
      );
    }
  },
};
